import { render } from "./UserInput.vue?vue&type=template&id=25e5e9f2&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=25e5e9f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e5e9f2"]])

export default __exports__